import apiWorker from '../apiWorker'

const review_link = {
    findById : (review_link) => apiWorker('get', `/v1/reviews/links/${review_link}`, null, true),
}

export default review_link;